import React from 'react';

import Button from '../../../elements/Button/Button';
import Icon from '../../../elements/icons/Icon';

const CloseButton = props => {
    const {onClose} = props;
    return (
        <Button className="Close" onClick={onClose}>
            {<Icon size={20} src={'img/reject_icon.png'} />}
        </Button>
    );
};

export default CloseButton;
